module.exports = __webpack_public_path__ + "static/media/tesseraworks1.862e08fe.png";